import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { VisaModel } from './VisaModel';

@Injectable({
  providedIn: 'root'
})
export class VisaService {

  
  constructor(private http: HttpClient ) { }
  baseUrl = environment.baseApiUrl;
  token = localStorage.getItem("token");
  httpOptions = {
   headers: new HttpHeaders({
     // 'Content-Type': 'application/json; charset=utf-8',
     // 'Authorization': "Bearer " + token,
      "Authorization": "Bearer " + this.token,
      "Content-Type": "application/json"
   })
 };

 getAll(): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}Visa/GetAll`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}


getById(Id:number): Observable<any> {

  return this.http
    .get<any>(`${this.baseUrl}Visa/GetById/${Id}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
insert(payload: VisaModel): Observable<any> {
  return this.http
    .post<any>(`${this.baseUrl}Visa/Insert`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
getAllByCountryId(CountryId:number): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}Visa/GetAllByCountryId/${CountryId}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
update(payload: VisaModel): Observable<any> {
  return this.http
    .post<any>(`${this.baseUrl}Visa/Update`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

delete(Id:number): Observable<any> {
  return this.http
    .get<any>(`${this.baseUrl}Visa/Delete/${Id}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}


}
